// Created by James Launder
// the top level for all of charting

import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useWindowDimensions from "../../Hooks/useWindowDimensions.js";
import ChartingDashBoard from "./ChartingDashboard.js";
import MainSection from "./MainSection.js";
import NavBar from "./NavBar.js";
import VertNav from "./VertNav.js";
import ChartErrorPopup from "./ChartErrorPopup.js";
import NotificationPopup from "./NotificationPopup.js";

function Charting() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [sidebar, setSidebar] = useState(true);
  const [loading, setLoading] = useState(true);
  const [fetching, setFetching] = useState(false);
  const [error, setError] = useState(false);
  const [graphName, setGraphName] = useState("");
  const [graphDescription, setGraphDescription] = useState("");
  const [graphResolution, setGraphResolution] = useState([]);
  const [graphDataSource, setGraphDataSource] = useState([]);
  const [graphSources, setGraphSources] = useState([]);
  const [show, setShow] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [resetCmp, setResetCmp] = useState(false);
  const [resetCharts, setResetCharts] = useState(false);
  const { width } = useWindowDimensions();
  // checks to see if the mobile width or not
  useEffect(() => {
    if (width <= 768) {
      setSidebar(false);
    } else {
      setSidebar(true);
    }
  }, [width]);
  // console.log("charting rendered");

  return (
    <div className="relative">
      {error ? (
        <main className="grid min-h-full place-items-center py-24 px-6 sm:py-32 lg:px-8 font-roboto">
          <div className="text-center">
            <p className="text-2xl font-semibold text-primary">404</p>
            <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
              Graph not found
            </h1>
            <p className="mt-6 text-base leading-7 text-gray-600">
              Sorry, we couldn’t find the page you’re looking for.
            </p>
            <div className="mt-6 flex items-center justify-center gap-x-6">
              <button
                onClick={() => {
                  navigate("/");
                }}
                className="rounded-lg bg-primaryContainer px-3 py-2 text-sm font-semibold text-black shadow-sm hover:text-white hover:bg-primary"
              >
                Go back home
              </button>
            </div>
          </div>
        </main>
      ) : (
        <div className="relative">
          <NavBar setSidebar={setSidebar} sidebar={sidebar} />
          <div className="flex flex-row relative z-0">
            <div className="absolute z-20 md:z-0 md:relative border-r-2 border-secondary">
              <VertNav
                setSidebar={setSidebar}
                sidebar={sidebar}
                loading={loading}
                setLoading={setLoading}
                setFetching={setFetching}
                setGraphName={setGraphName}
                setGraphDescription={setGraphDescription}
                setGraphResolution={setGraphResolution}
                setGraphDataSource={setGraphDataSource}
                setGraphSources={setGraphSources}
                setError={setError}
                setResetCmp={setResetCmp}
                setResetCharts={setResetCharts}
                // setGraphId={setGraphId}
              />
            </div>

            {searchParams.get("name") ? (
              <MainSection
                sidebar={sidebar}
                graphName={graphName}
                graphDescription={graphDescription}
                graphResolution={graphResolution}
                graphDataSource={graphDataSource}
                graphSources={graphSources}
                loading={loading}
                fetching={fetching}
                showError={show}
                setShowError={setShow}
                errorMessage={errorMessage}
                setErrorMessage={setErrorMessage}
                resetCmp={resetCmp}
                setResetCmp={setResetCmp}
                setResetCharts={setResetCharts}
                resetCharts={resetCharts}
              />
            ) : (
              <ChartingDashBoard sidebar={sidebar} />
            )}
          </div>
          <div className="absolute z-30">
            <NotificationPopup />
            <ChartErrorPopup
              show={show}
              setShow={setShow}
              message={errorMessage}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default Charting;
